module.exports = __webpack_public_path__ + "images/emoji/sweet_potato.dddb4300f6b02692e18f.png";